import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import "./assets/css/common.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* basename="/fitpro" */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
